<template>
  <q-table ref="tableRef"
           flat
           :loading="loading"
           :columns="columns"
           :rows="rows"
           :filter="search"
           @row-click="rowClick"
           v-model:pagination="pagination"
           :selection="admin ? 'multiple' : 'none'"
           v-model:selected="selected"
           @request="onRequest" row-key="id">
    <template #body-cell-name="props">
      <q-td :props="props">
        <avatar size="24px" :project="props.row" class="q-mr-sm"/>
        {{ props.row.name }}
      </q-td>
    </template>

  </q-table>
</template>

<script setup lang="ts">
import {onMounted, ref, toRefs, useModel, watch} from "vue"
import {Page, Pagination} from "../models/common";
import {useProjects} from "../composables/project";
import {Project} from "../models/project";
import {useRouter} from "vue-router"
import Avatar from "./Avatar.vue";
import {UseFetchReturn, useStorage} from "@vueuse/core";

const selected = defineModel<Project[]>()

const props = defineProps<{
  fetch: (pagination: Pagination) => UseFetchReturn<Page<Project>>,
  search: string,
  admin: boolean
}>()

const {fetch: fetchProjects, admin} = toRefs(props)
const router = useRouter()
const tableRef = ref()
const loading = ref(false)
watch(fetchProjects, () => {
  pagination.value.rowsPerPage = 10
})

const columns = [
  {
    name: 'name',
    required: true,
    label: 'Проект',
    align: 'left',
    field: 'name',
    sortable: true
  },
  {name: 'code', align: 'center', label: 'Код', field: 'code', sortable: true},
  {
    name: 'projectType', label: 'Категория', field: (row: Project) => row.type?.name,
    format: (val: string | null) => val ?? "Отсутствует", sortable: true
  },
  {
    name: 'organization', label: 'Организация', field: (row: Project) => row.organization?.name,
    format: (val: string | null) => val ?? "Отсутствует", sortable: true
  },
  {name: 'owner', label: 'Создатель', field: (row: Project) => row.owner?.username},
]

const pagination = useStorage('pagination', {
  sortBy: 'createdAt',
  descending: false,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 10
})

const rows = ref<Project[]>([])

async function onRequest(prop: Pagination) {
  const {page, rowsPerPage, sortBy, descending} = prop.pagination
  loading.value = true
  const {data} = await props.fetch(prop)
  rows.value = data.value?.content ?? []
  pagination.value.rowsNumber = data.value?.totalElements ?? 0
  pagination.value.page = page
  pagination.value.rowsPerPage = rowsPerPage
  pagination.value.sortBy = sortBy
  pagination.value.descending = descending

  loading.value = false
}

async function rowClick(evt: Event, row: any, index: number) {
  await router.push(`/projects/${row.id}/tasks`)
}

onMounted(() => {
  fetch()
})

function fetch() {
  tableRef.value.requestServerInteraction()
}

defineExpose({
  fetch
})
</script>

<style scoped></style>